export const DEFAULT_TONE = {
  id: 1,
  title: 'Professional'
};
